import script from "./perfil.vue?vue&type=script&setup=true&lang=js"
export * from "./perfil.vue?vue&type=script&setup=true&lang=js"

import "./perfil.vue?vue&type=style&index=0&id=83f3ef32&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83f3ef32"]])

export default __exports__